import React from "react";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { format, isValid } from 'date-fns';
// import DateRangePicker from "../ReusableComponents/BookingRangePicker";
import TextArea from '../ReusableComponents/TextArea';
const TariffMasterPopup = ({ data, data1 }) => {

  return (
    <>
      <div className="flex justify-center">
        <div className="grid gap-4 mb-2 md:grid-cols-2 w-full md:w-1/2 items-center">


       <AutoDropDown
                  selectedOption={{ value: data.RoomType, label: data.RoomTypeName }}
                  title="Room Type"
                  classStar={"text-red-500"}
                  inputType="dropdown"
                  options={data1}
                  name="roomType"
                  disabled={true}
                  placeholder="Room Type"
                  Class="custom-class"
                  // tabIndex="1"
                  maxLength={50}
                />






          <InputText
            inputType="text"
            title="Base Tariff (₹)"
            name="BaseTariff"
            classStar="text-red-500"
            content={data?.BaseTariff || ""}
            disabled={true}
          />

          <InputText
            inputType="text"
            title="Holiday Tariff (₹)"
            name="HolidayTariff"
            classStar="text-red-500"
            content={data?.HolidayTariff || ""}
            disabled={true}
          />

          {/* <InputText
            inputType="text"
            title="Special Tariff (₹)"
            name="SpecialTariff"
            classStar="text-red-500"
            content={data?.SpecialTariff || ""}
            disabled={true}
          /> */}

          <InputText
            inputType="date"
            title="WEF"
            name="wef"
             classStar={"text-red-500"}
            content={
              data.WEF && isValid(new Date(data.WEF))
                ? format(new Date(data.WEF), "yyyy-MM-dd")
                : ""
            }
            disabled={true}
          />

          {/* <InputText
            inputType="text"
            title="Description"
            name="Description"
          
            content={data?.Description || ""}
            disabled={true}
          /> */}
        <div className="col-span-2">
          <TextArea
          title="Description"
          rows={7}
          name="description"
          content={data?.Description}
          resize={false}
          placeholder="Enter description"
          disabled={true}
          // tabIndex="0"
        />

          </div>

        </div>
      </div>
    </>
  );
};

export default TariffMasterPopup;
